import CourtPageV2 from './CourtPageV2';

export default CourtPageV2;

export { type Props } from './types';
